import {Controller} from "stimulus"
import axios from "axios"

export default class extends Controller {
  static targets = ['copyButton', 'testIdentifier', 'accessionIds']

  async fetchData(copyType) {
    return axios({
      method: 'GET',
      url: "/test_results/specimen_nums.json",
      params: {
        test_identifier: this.testIdentifierTarget.value,
        accession_ids: this.accessionIdsTarget.value,
        copy_type: copyType
      }
    })
  }

  copyDataToClipboard(event) {
    event.preventDefault()
    const copyType = event.target.dataset.copyType
    this.fetchData(copyType)
      .then((res) => {
        const specimenNumbers = res.data.specimen_nums
        const copyButton = this.copyButtonTarget
        copyToClipboard(specimenNumbers.join('\n'))

        copyButton.setAttribute('data-original-title', $.t('Copied'))
        const tooltip = new bootstrap.Tooltip(copyButton)
        tooltip.show()
        setTimeout(() => {
          copyButton.setAttribute('data-original-title', $.t('Copy to Clipboard'))
          tooltip.hide()
        }, 1000)
      })
  }
}
